import { render, staticRenderFns } from "./VFatherProAnamAN.vue?vue&type=template&id=1f925ea9"
import script from "./VFatherProAnamAN.vue?vue&type=script&lang=js"
export * from "./VFatherProAnamAN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports